import React from 'react';

const DownloadSection = () => {
  return (
    <section
      id="download"
      data-testid="download-section"
      className="bg-[#0c3a2a] py-20"
    >
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto">
          {/* Headline */}
          <h2
            data-testid="download-headline"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#FAFAF7] leading-tight mb-4"
          >
            Start Your Financial
            <br />
            Transformation Today
          </h2>
          
          {/* Subtext */}
          <p className="font-body text-lg text-[#95B8A2] mb-4">
            Free forever plan. No credit card required.
          </p>
          
          {/* Coming Soon Badge */}
          <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 border border-[#D4AF37]/40 rounded-full px-4 py-2 mb-10">
            <span className="w-2 h-2 bg-[#D4AF37] rounded-full animate-pulse"></span>
            <span className="font-body text-sm text-[#D4AF37] font-semibold">Coming Soon to iOS & Android</span>
          </div>

          {/* App Store Badges - Coming Soon */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <div
              data-testid="download-appstore-button"
              className="relative inline-block opacity-80"
            >
              <img 
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" 
                alt="Coming soon to App Store" 
                className="h-14 sm:h-16 grayscale-[30%]"
              />
              <span className="absolute -top-2 -right-2 bg-[#D4AF37] text-[#1B4332] text-[10px] font-body font-bold px-2 py-0.5 rounded-full shadow-lg">
                SOON
              </span>
            </div>
            <div
              data-testid="download-googleplay-button"
              className="relative inline-block opacity-80"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Coming soon to Google Play" 
                className="h-14 sm:h-16 grayscale-[30%]"
              />
              <span className="absolute -top-2 -right-2 bg-[#D4AF37] text-[#1B4332] text-[10px] font-body font-bold px-2 py-0.5 rounded-full shadow-lg">
                SOON
              </span>
            </div>
          </div>

          {/* Email Signup Teaser */}
          <p className="font-body text-sm text-[#FAFAF7]/60">
            Be the first to know when we launch.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
